import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

const LOW_STOCK_COUNT_SENTINEL = '987654321';

class ProductInventory extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const html = event.detail.data.html;
    if (!html) {
      this.#updateInventoryFromVariant(event.detail.resource);
      return;
    }

    const newInventory = html.querySelector('product-inventory');

    if (!newInventory) return;

    morph(this, newInventory, { childrenOnly: true });
  };

  /**
   * @param {{
   *   available?: boolean,
   *   inventory_management?: string | null,
   *   inventory_policy?: string,
   *   inventory_quantity?: number
   * } | null} variant
   */
  #updateInventoryFromVariant(variant) {
    const icon = this.querySelector('.product-inventory__icon');
    const text = this.querySelector('.product-inventory__text');
    if (!(icon instanceof HTMLElement) || !(text instanceof HTMLElement)) return;

    const threshold = Number(this.dataset.threshold);
    const showQuantity = this.dataset.showQuantity === 'true';
    const quantity = Number(variant?.inventory_quantity ?? 0);
    const managed = variant?.inventory_management === 'shopify';

    /** @type {'low' | 'in_stock' | 'out_of_stock'} */
    let status = 'out_of_stock';
    let label = this.dataset.textOutOfStock || '';

    if (!variant) {
      status = 'out_of_stock';
      label = this.dataset.textOutOfStock || '';
    } else if (managed) {
      if (quantity > 0) {
        if (Number.isFinite(threshold) && quantity <= threshold) {
          status = 'low';
          if (showQuantity) {
            const template = this.dataset.textLowStockCount || '';
            label = template.replace(LOW_STOCK_COUNT_SENTINEL, String(quantity));
          } else {
            label = this.dataset.textLowStock || '';
          }
        } else {
          status = 'in_stock';
          label = this.dataset.textInStock || '';
        }
      } else if (variant.inventory_policy === 'continue') {
        status = 'in_stock';
        label = this.dataset.textInStock || '';
      } else {
        status = 'out_of_stock';
        label = this.dataset.textOutOfStock || '';
      }
    } else {
      status = 'in_stock';
      label = this.dataset.textInStock || '';
    }

    icon.classList.remove(
      'product-inventory__icon-low',
      'product-inventory__icon-in_stock',
      'product-inventory__icon-out_of_stock'
    );
    icon.classList.add(`product-inventory__icon-${status}`);
    text.textContent = label;
  }
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
